import { Type } from '@angular/core';
import { AbstractFilterComponent } from './filter/base.filter.component';
import { environment } from '../../../environments/environment';
import {CustomerServiceImpl} from "../../services/customer/customer.service.impl";

export interface AbstractFilterModule {
  module?: Type<any>
  component: Type<AbstractFilterComponent>
}

export async function GetFilterComponent(): Promise<AbstractFilterModule | undefined> {
  switch (CustomerServiceImpl.GetCustomerKey().toLowerCase()) {
    case 'deinetuer':
    case 'tuerenshop':
    case 'doorsuppliesonline':
    case 'overheaddoor':
    case 'wayne-dalton':
    case 'andersenwindows':
      const {GenericFilterModule} = await import('./generic-filter/generic-filter.module');

      return {
        module: GenericFilterModule,
        component: GenericFilterModule.components.GenericFilterComponent
      };

    default:
      return undefined;
  }
}
